import React, { useContext } from "react";
// import { getCountriesData } from "lib/countries";

import { useDataSummary, useMapData } from "lib/api/distancing/data-summary";

export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_KEY;
export const BASELINE_DATES = ["2020-03-02", "2020-03-02"];

export const BASELINE_DATE = BASELINE_DATES[0];

// export const availableCountries = getCountriesData();

export const availableLanguages = {
  en: "English",
  es: "Español",
  pt: "Português",
};

export const CASES_KEY = "cumulativeCases";

// Config is now in context.

const ConfigContext = React.createContext({});

export function ConfigProvider({ children }) {
  const { data: summaryData } = useDataSummary({
    suspense: true,
  });

  const { data: mapData } = useMapData({
    suspense: true,
  });

  const config = {
    dates: summaryData,
    mapData,
  };

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
}


export function useCountryCenter(country) {
  const countryData = useCountryData(country)

  return countryData;
}

export function useStateCenter(country, state) {
  const stateData = useStateData(country, state);

  return stateData;
}

export function useCountyCenter(country, state, county) {
  // TODO: Return real level 3 center.
  const stateData = useStateData(country, state);

  return stateData;
}


export function useCountryData(countryId) {
  const config = useContext(ConfigContext);
  return config.mapData[countryId]
}


export function useDefaultCountryId() {
  return useAvailableCountries()[0].id
}

export function useDefaultStateId(countryId) {
  const config = useContext(ConfigContext);

  return Object.keys(config.mapData[countryId].level1Centers)[0];
}

export function useStateData(countryId, stateId) {
  const config = useContext(ConfigContext);

  return config.mapData[countryId]?.level1Centers[stateId]
}


export function useAvailableCountries() {
  const config = useContext(ConfigContext);

  return Object.values(config.mapData);
}

export function useCountriesData() {
  const config = useContext(ConfigContext);
  return config.mapData;
}

export function useStatesData(countryId) {
  const config = useContext(ConfigContext);
  return config.mapData[countryId].level1Centers;
}

export function useAvailableStates(country) {
  const config = useContext(ConfigContext);

  if (!country) {
    return null;
  }

  return Object.values(config.mapData[country].level1Centers);
}

export function useDataDates() {
  const config = useContext(ConfigContext);

  return config.dates;
}
